<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getRGBA } from '@/util/prowers'
export default {
  name: 'App',
  mounted() {
    if (process.env !== 'production') console.log('process.env', process.env)
    window.document.body.style.setProperty(
      '--theme-color',
      this.$regional.backgroundColor
    )
    window.document.body.style.setProperty(
      '--theme-background',
      getRGBA(this.$regional.backgroundColor, 0.04)
    )
  }
}
</script>

<style>
html,
body {
  height: 100%;
}
#app {
  font-family: "Microsoft YaHei", "微软雅黑", "Helvetica Neue", Helvetica,
    "PingFang SC", "Hiragino Sans GB", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #484f62;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue